<template >
  <div>
    <div class="sr-comInfo">
      <div class="sr-layout-wrap">
        <el-image src="https://sara-infinity.com/logo.jpg" style="float: left; height: 10%;width: 10%"  />

        <div class="sr-comInfo-r" style="margin-top: 3%;margin-left: 3%">
        <div class="sr-comInfo-title J-title-comName">
            <div class="title-txt">
              <a href="https://www.sara-infinity.com">
                <h1  style="font-size: 22px">
                  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.<i class="ob-icon icon-down"></i>
                </h1>
              </a>
            </div>

          </div>
          <div class="sr-comInfo-sign">
            <div class="sign-item">
              <i class="el-icon-message"></i> <span class="txt-year">525205929@qq.com</span>
              <div class="tip arrow-top tip-gold">
                <div class="tip-con">
                  <p class="tip-para">Suppliers with verified business licenses</p>
                </div>
                <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
              </div>
            </div>
            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-phone"></i>
              <span class="txt-year">+86 18680557608</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-menu
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="padding-left: 21.2%">
      <el-menu-item index="1"><router-link to="/home" target="_blank">Home</router-link></el-menu-item>
      <el-menu-item index="2"><router-link to="/products" target="_blank">Products</router-link></el-menu-item>
      <el-menu-item index="3" ><router-link to="/aboutUs" target="_blank">About Us</router-link></el-menu-item>
      <el-menu-item index="4" disabled><router-link to="" target="_blank">Solutions</router-link></el-menu-item>
      <el-menu-item index="5"><router-link to="/sendUs" target="_blank">Send Us</router-link></el-menu-item>
    </el-menu>





    <div class="sr-layout-detail clears" style="margin-top: 2%">
      <div class="sr-detail-content clears">


        <div class="sr-layout-content sr-proMainInfo" style="width: 70%">
          <div class="sr-proMainInfo-slide J-pic-box">
            <div class="tip-online J-sample-online-tips" style="display: none">
              <ul class="tip-cont">
                <li>
                  <span class="online-icon online-icon-1"></span>
                  <span>On-Site Scanning</span>
                </li>
                <li>
                  <span class="online-icon online-icon-2"></span>
                  <span>Precise Digital Duplicate</span>
                </li>
                <li>
                  <span class="online-icon online-icon-3"></span>
                  <span>Angle Unlimited</span>
                </li>
              </ul>
            </div>
            <input type="hidden" id="prodId" value=""/>
            <div class="sr-proMainInfo-slide-pic J-pic-list-wrap sr-proSlide">
              <div class="sr-proMainInfo-slide-container swiper-container J-pic-list-container">
                <div class="swiper-wrapper">
                  <div class="sr-proMainInfo-slide-picItem swiper-slide enlarge-hide J-pic-large-item J-pic-item">
                    <div class="sr-prMainInfo-slide-inner">
                      <div class="sr-proMainInfo-slide-picInside">
                        <a class="enlargeHref"
                           href=""
                           title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                          <img src="https://sara-infinity.com/1.png" style="width: 100%;"
                               alt="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150 pictures & photos"
                               title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                        </a>
                      </div>

                    </div>
                  </div>


                </div>

              </div>
            </div>

            <div class="fav-share-wrap">
                <span class="act-item">
                    <a fun-favorite rel="nofollow" href="javascript:void(0);"
                       class="J-added-to-product-fav link-with-icon J-add2Fav J-added already-fav-new"
                       cz-username="hspcylinder" cz-sourceid="pvImKCyLaEfT" cz-sourcetype="prod" style="display:none"><i
                        class="J-fav-icon ob-icon icon-heart-f"></i>Favorites</a>
                    <a fun-favorite rel="nofollow" href="javascript:void(0);"
                       class="J-add-to-product-fav link-with-icon J-add2Fav" cz-username="hspcylinder"
                       cz-sourceid="pvImKCyLaEfT" cz-sourcetype="prod" style=""
                       ads-data="st:17,pdid:pvImKCyLaEfT,pcid:MbqJekDAbTiS"><i
                        class="J-fav-icon ob-icon icon-heart"></i>Favorites</a>
                </span>
              <span class="act-item share-wrap">
                    <span class="share-link">
                        <i class="ob-icon icon-share1"></i> Share
                    </span>
                    <div class="share-cnt cf">
                                                    <div id="J-sns-icons"
                                                         data-Image=""
                                                         data-Desc=""
                                                         data-fblink="m_medium=free&utm_campaign=showroom_share&utm_source=facebook"
                                                         data-twlink=""
                                                         data-ptlink=""
                                                         data-ldlink=""
                                                    ></div>
                                                <div class="mail link-blue fr">
                            <iframe src="about:blank" frameborder="0" id="I-email-this-page" name="I-email-this-page"
                                    width="0" height="0" style="width:0;height:0;"></iframe>
                            <a class="micpm"
                               href=""
                               rel="nofollow" title="Email" target="I-email-this-page"><i class="micon"
                                                                                          title="Email this page"></i></a>
                        </div>
                    </div>
                </span>
            </div>
            <div class="sr-proMainInfo-baseInfo-actDload J-download-catalog-label" style="display:none">
              <div class="link-wrap">
                <a rel="nofollow" class="link J-cat-link" href="javascript:void(0)" target="download-catalog">
                  <i class="ob-icon icon-pdf"></i>
                  Download Product Catalog
                  <i class="ob-icon icon-info"></i>
                </a>
                <div class="tip arrow-top">
                  <div class="tip-con J-cat-cnt"></div>
                  <span class="arrow arrow-out">
                            <span class="arrow arrow-in"></span>
                        </span>
                </div>
              </div>
            </div>
          </div>
          <div class="J-picGifDialog" id="J-picGifDialog" style="display:none;">
            <div class="picGifDialog">
              <div id="picRoundBox" style="width:600px;"></div>
              <div class="picRoundTool J-picRoundTool">
                <i class="ob-icon icon-pause J-stop"></i>
                <i class="ob-icon icon-play J-start"></i>
              </div>
              <div style="position: absolute;width: 600px; height: 100%; top: 0;left: 0;"></div>
            </div>
          </div>
          <div class="sr-proMainInfo-baseInfo">
            <div class="sr-proMainInfo-baseInfo-name">
              <h1 class="sr-proMainInfo-baseInfoH1 J-baseInfo-name" data-prod-tag="">
                High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150
              </h1>
            </div>
            <div class="sr-proMainInfo-baseInfo-property">
              <div class="baseInfo-price-related">
                <input type="hidden" id="inquiry4PriceHref" name="inquiry4PriceHref"
                       value="">
                <div class="swiper-proMainInfo-baseInfo-propertyGetPrice-container">
                  <div class="first-container">
                    <div style="display: flex;">
                      <div class="title-div">
                        Reference FOB Price / Purchase Qty.
                      </div>
                      <i id="pricePropIcon" class="ft-icon icon-info"></i>
                    </div>
                    <div class="inquiry-tools cf">
                      <a rel="nofollow" class="sr-proMainInfo-baseInfo-propertyGetPrice" id="latestPriceInquiry"
                         href="javascript:;">
                        Get Latest Price <i class="ob-icon icon-right"></i>
                      </a>
                    </div>
                  </div>
                  <input type="hidden" value="{'Payment Terms':'L/C, T/T, Western Union','Port':'Ningbo, China'}"
                         id="priceProp">
                  <div class="sr-proMainInfo-baseInfo-propertyPrice">
                    <div id="swiper-container" class="swiper-container-div">
                      <div class="swiper-wrapper-div">
                        <div class="swiper-slide-div">
                          <div class="swiper-money-container">US $10.00</div>
                          <div class="swiper-unit-container">100-499 <span class="unit">Sets</span></div>
                        </div>
                        <div class="swiper-slide-div">
                          <div class="swiper-money-container">US $9.00</div>
                          <div class="swiper-unit-container">500+ <span class="unit">Sets</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="J-coupon-box"></div>
              </div>
              <input type="hidden" id="login" value="false">
              <div class="sr-proMainInfo-baseInfo-propertyAttr">
                <div class="attr-line"></div>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">Type:</th>
                    <td>Motorcycle Engine Assembly</td>
                  </tr>
                  <tr>
                    <th width="160" class="th-label">Start:</th>
                    <td>Electric</td>
                  </tr>
                  <tr>
                    <th width="160" class="th-label">Cylinder NO.:</th>
                    <td>1 Cylinder</td>
                  </tr>
                  </tbody>
                </table>
                <div class="attr-line"></div>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">Samples:</th>
                    <td>
                      <div class="sample-order-info">
                        <div class="info-text">
                          <strong class="red">US$ 15/Set</strong>
                          <span title="1 Set(Min.Order)">1 Set(Min.Order)</span>
                        </div>
                        <span class="gap">|</span>
                        <a target="_blank" rel="nofollow"
                           href=""
                           ads-data="st:122">
                          <i class="ob-icon icon-product"></i>Order Sample
                        </a>
                      </div>
                      <div class="sample-order-desc"></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">Customization:</th>
                    <td>
                      <div class="sample-order-info">
                        <div class="info-text">
                          Available
                        </div>
                        <span class="gap">|</span>
                        <a target="_blank" rel="nofollow"
                           href="//purchase.made-in-china.com/send-customized-request/prod/pvImKCyLaEfT.html">
                          <i class="ob-icon icon-fill"></i>Customized Request
                        </a>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <div class="attr-line"></div>
                <input type="hidden" id="aimArea" value="China"/>
                <table class="est-price J-est-price">
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">
                      Shipping Cost:
                      <div class="freight-tips help-tips J-help">
                        <i class="ob-icon icon-problem"></i>
                        <div class="tips tips-system J-tips">
                          <div class="tips-con">
                            <p>Estimated freight per unit.</p>
                            <span class="arrow arrow-top">
													<span class="arrow arrow-in"></span>
												</span>
                          </div>
                        </div>
                      </div>
                    </th>
                    <td>
                                        <span class="shipping-cost-tm" ads-data="st:13">
                                            <b
                                                text='[{"offline": {"text":"Negotiate with supplier","title":"Negotiate with supplier"}, "online": {"text":"Negotiate with supplier","title":"Negotiate with supplier"}}]'
                                                class="tm3_chat_status"
                                                dataId="MbqJekDAbTiS_pvImKCyLaEfT_1"
                                                inquiry=""
                                                processor="chat"
                                                cid="MbqJekDAbTiS"
                                                style="display:none">
                                            </b>
                                        </span>
                      about shipping cost and estimated delivery time.
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label" style="padding-bottom: 10px">Payment Method:
                    </th>
                    <td>
                                    <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="visa" data>
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="mastercard">
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src="/"
                                             data-original=""
                                             width="40" height="23" alt="discover">
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="JCB">
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="diners club">
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="american express">
                                    </span>
                      <span style="display: inline-block;margin-right: 8px;width: 40px;height: 23px;">
                                        <img src=""
                                             data-original=""
                                             width="40" height="23" alt="T/T">
                                    </span>
                    </td>
                  </tr>
                  <tr>
                    <th width="160" class="th-label">&nbsp;
                    </th>
                    <td>
                                    <span style="margin-right: 40px;color: #888;">
                                        <i class="ob-icon icon-yes2" style="color: #13BF13"></i>
                                        Initial Payment
                                    </span>
                      <span style="margin-right: 40px;color: #888;">
                                        <i class="ob-icon icon-yes2" style="color: #13BF13"></i>
                                        Full Payment
                                    </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">Currency:
                    </th>
                    <td>
                      <span id="tradeCurrency" style="cursor: pointer;font-size: 16px;">US$</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                  <tr>
                    <th width="160" class="th-label">Return&refunds:
                    </th>
                    <td>
                      You can apply for a refund up to 30 days after receipt of the products.
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="sr-proMainInfo-baseInfo-act">
            </div>
          </div>
          <input type="hidden" id="contactNow"
                >
          <input type="hidden" id="supportOrder" value="true"
                 >

        </div>


        <div class="sr-layout-right" style="margin-top: -675px">
          <div class="sr-layout-block sr-contact-button-place block-top">
            <div faw-module="sendInquiry" faw-exposure>
              <div>
                <div class="J-order-text order-text">
                  <div class="flex-box">
                    <div class="flex-text" style="font-weight: bold">
                      From payment to delivery, we protect your trading.
                    </div>
                  </div>
                </div>
                <div class="sr-side-product-info J-product-info">
                  <div class="sr-side-product-img">
                    <img
                        src="//image.made-in-china.com/200f0j00DPaYTfpgunqS/High-Quality-Motorcycle-Parts-Cylinder-Kit-for-Honda-CG150-AKT150-SY150-EVO-NE-AKT150TT-EVO150.webp"
                        alt="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150 pictures & photos"
                        title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                  </div>
                  <div class="sr-side-product-txt">
                    <div class="sr-side-product-name"
                         title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                      High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150
                    </div>
                    <div class="sr-side-product-price" title="US $9-10 / Set">
                      <span class="sr-side-product-num">US $9-10 </span>
                      <span class="sr-side-product-unit">/ Set</span>
                    </div>
                    <div class="sr-side-product-price" title="Min. Order: 100 Sets">
                      <span class="sr-side-product-unit">Min. Order: </span>
                      100 Sets
                    </div>
                  </div>
                </div>

                <div class="button-block">
                  <a fun-inquiry-product class="btns button-link-contact" target="_blank"
                     href=""
                     rel="nofollow" ads-data="st:5,pdid:pvImKCyLaEfT,pcid:MbqJekDAbTiS"><i
                      class="ob-icon icon-mail"></i>Contact Now</a>
                </div>

                <div class="button-block sr-proMainInfo-baseInfo-actActs">
            <span class="act-item">
    <span class="J-added-to-basket already-in-basket pvImKCyLaEfT" style="display:none">
         <a href="javascript:;" onclick="showMiniInquiry('product');"
            ads-data="st:6,pdid:pvImKCyLaEfT,pcid:MbqJekDAbTiS">
              <i class="micon">&#xe05f;</i>Inquiry Basket </a>
     </span>
    <span class="J-add-to-basket pvImKCyLaEfT add-to-basket" style="">


            </span>
</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sr-layout-block sr-com-place sr-com-place-top">
            <div faw-module="verified_company_homepage" faw-exposure>
              <input type="hidden" id="J-linkInfo" >
              <div class="sr-linkTo-comInfo J-linkTo-comInfo" ads-data>
                <div class="sr-com com-place-one com-place-one-new">
                  <div class="sr-com-logo">
                    <img src=""
                         />
                  </div>
                  <div class="sr-com-info">
                    <div class="sr-comInfo-title ">
                      <div class="title-txt">
                        <a  target="_blank" ads-data
                           title="  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.">  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD. </a>
                      </div>
                    </div>
                  </div>
                  <div class="detail-infos">
                    <div class="info-item">
                     <span class="info-item info-businessType" title="Manufacturer/Factory">
                                        Manufacturer/Factory
                                    </span>
                    </div>
                  </div>
                </div>
                <div class="sr-comInfo-sign com-place-two com-place-two-new ">
                  <div class="sign-item">
                    <i class="item-icon icon-gold"></i>
                    Gold Member <span class="txt-year">Since 2019</span>
                    <div class="tip arrow-bottom tip-gold">
                      <div class="gold-content">
                        <div class="tip-con">
                          <p class="tip-para">Suppliers with verified business licenses</p>
                        </div>
                        <span class="arrow arrow-out">
                            <span class="arrow arrow-in"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="sign-item" style="margin-top: 8px">
                    <i class="item-icon icon-deal"></i>
                    Secured Trading Service
                  </div>
                  <div class="review-scores">
                    <div class="score-item score-item-rating">
                      Rating:
                      <span>
                            <a class="J-company-review" target="_self"
                               href="">4.6/5</a></span>
                    </div>
                    <div></div>
                    <div class="company-location">
                      <i class="ob-icon icon-coordinate"></i>
                      <div class="tip arrow-bottom tip-gold">
                        <div class="gold-content">
                          <div class="tip-con">
                            Zhejiang, China
                          </div>
                          <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="com-place-three com-place-three-new">
                <div class="sign-item as-logo J-verified-item" style="margin-top: 5px"
                     data-title="Audited by an independent third-party inspection agency">
                  <img class="item-icon" src=""
                      alt=""/>
                  Audited Supplier
                </div>
                <div class="see-all no-sign">
                  <a class="J-sign-in" href="javascript:void(0);">Sign In</a> to see all verified strength labels (21)
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="sr-container J-layout ">
      <div class="sr-layout-wrap sr-layout-resp">
        <div class="sr-layout-main">
          <div class="sr-layout-block detail-tab J-tabs">
            <div class="J-full-tab" style="display: none"></div>
            <div class="com-block-tab cf J-fixed-tab">
              <a class="tab-item J-tab current"><h3>Product Description</h3></a>
              <!--              <a class="tab-item J-tab"><h3>Company Info.</h3></a>-->
            </div>
            <div class="sr-layout-subblock detail-tab-item J-tab-cnt">
              <div class="sr-layout-block bsc-info">
                <div class="sr-layout-subblock">
                  <div class="sr-txt-title">
                    <h2 class="sr-txt-h2">Basic Info.</h2>
                  </div>
                  <div class="sr-layout-content">
                    <div class="basic-info-list">
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Model NO.</div>
                        <div class="bac-item-value fl">CG150 AKT150 SY150</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Stroke</div>
                        <div class="bac-item-value fl">Four Stroke</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Cold Style</div>
                        <div class="bac-item-value fl">Air-Cooled</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Energy Transformation</div>
                        <div class="bac-item-value fl">Thermal Machine</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Certification</div>
                        <div class="bac-item-value fl">CE</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Thermal Machine</div>
                        <div class="bac-item-value fl">Internal Combustion Type</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Four Stroke Principle</div>
                        <div class="bac-item-value fl">Exhaust Stroke</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Main Market</div>
                        <div class="bac-item-value fl">South America</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Transport Package</div>
                        <div class="bac-item-value fl">Inner Box + 5 Layer Carton</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Specification</div>
                        <div class="bac-item-value fl">12pcs/ctn; carton volume; 430x320x220mm</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Trademark</div>
                        <div class="bac-item-value fl">HSP</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Origin</div>
                        <div class="bac-item-value fl">Ningbo, China</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">HS Code</div>
                        <div class="bac-item-value fl">8409919990</div>
                      </div>
                      <div class="bsc-item cf">
                        <div class="bac-item-label fl">Production Capacity</div>
                        <div class="bac-item-value fl">100, 000 PCS/Year</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sr-layout-subblock">
                  <div class="sr-txt-title">
                    <h2 class="sr-txt-h2">Packaging & Delivery</h2>
                  </div>
                  <div class="sr-layout-content">
                    <div class="basic-info-list">
                      <div class="bsc-item full cf">
                        <div class="bac-item-label fl">Package Size</div>
                        <div class="bac-item-value fl">17.00cm * 17.00cm * 17.00cm</div>
                      </div>
                      <div class="bsc-item full cf">
                        <div class="bac-item-label fl">Package Gross Weight</div>
                        <div class="bac-item-value fl">1.600kg</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sr-layout-content detail-desc">
                <div class="sr-txt-title">
                  <h2 class="sr-txt-h2">Product Description</h2>
                </div>
                <div class="async-rich-info">
                  <div class="rich-text cf">
                    <html>
                    <head></head>
                    <body>
                    <div style="text-align:center;">
                      <span style="font-size:20px;"><strong>High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150</strong></span>
                    </div>
                    <div class="rich-text-table">
                      <table style="max-width:1060px;">
                        <colgroup>
                          <col>
                          <col>
                        </colgroup>
                        <tbody>
                        <tr>
                          <td>Product Name</td>
                          <td>Cylinder</td>
                        </tr>
                        <tr>
                          <td>Model</td>
                          <td><strong>CG150/AKT150/SY150</strong></td>
                        </tr>
                        <tr>
                          <td>Bore Size</td>
                          <td>62.00mm/62.00mm/65.50mm</td>
                        </tr>
                        <tr>
                          <td>Total Height</td>
                          <td>98.00mm</td>
                        </tr>
                        <tr>
                          <td>Face To Face Height</td>
                          <td>68.55mm/69.10mm/69.50mm</td>
                        </tr>
                        <tr>
                          <td>Piston Pin</td>
                          <td>15.00mm/13.00mm/15.00mm</td>
                        </tr>
                        <tr>
                          <td>Piston Ring</td>
                          <td>1.2*1.2*2.5/1.0*1.0*2.0/0.8*0.8*2.8/(mm^3)</td>
                        </tr>
                        <tr>
                          <td>Material</td>
                          <td>Aluminum</td>
                        </tr>
                        <tr>
                          <td>Color</td>
                          <td>Silver/Black/Gray</td>
                        </tr>
                        <tr>
                          <td>Sample</td>
                          <td>Free Sample Available</td>
                        </tr>
                        <tr>
                          <td>Logo</td>
                          <td>HSP And Customer Logo Available</td>
                        </tr>
                        <tr>
                          <td>Package</td>
                          <td>Netural Box Or Customer Designed Color Box</td>
                        </tr>
                        <tr>
                          <td>Delivery Time</td>
                          <td>Approximately 20 days</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="rich-text-table">
                      <table style="max-width:1060px;">
                        <colgroup>
                          <col>
                          <col>
                        </colgroup>
                        <tbody>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>SOUTH AMERICA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>BAJAJ BOXER CT100,BAJAJ BOXER BM100,BAJAJ BOXER BM150, BAJAJ PULSAR135, BAJAJ PULSAR1150, BAJAJ PULSAR180, BAJAJ PULSAR200, BAJAJ PULSAR220, BAJAJ DISCOVER125,&nbsp;BAJAJ DISCOVER135, BAJAJ XCD125, BAJAJ 2T 3W, BAJAJ 4T 3W, BAJAJ CALIBER115, HONDA C100 WAVE, HONDA CGL125, HONDA NXR125 BROS, HONDA STORM125CC, HONDA TWISTER 250CC, HONDA XLR250-XR250, HONDA XL/XR/NX200, JIALING JH100-2, JIALING JH125-6, JIALING JH150T CHOPPER, JIALING JL125T SCOOTER, KAWASAKI WIND125, KYMCO ACTIV110, SUZUKI DR200, YAMAHA XT225, YAMAHA XTZ125K, YUMBO DAKAR150, YUMBO DAKAR220, YAMAHA JOG/3KJ50, FT200, TITAN2000, TITAN150, TITAN99, CG125, HJ125-7, GXT200&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>EUROPE &amp; AMERICA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>CX50, YAMAHA50, AG50, NR50, NRG50, WATER, BUXY50, KATANA50, KATANA70, LEAD50, BALI50 SFX50, SKY, BALJ50, GY6-50, GY6-60,&nbsp;GY6-80, GY6-150,&nbsp;CX50, DJ50, BUXY50, JOG50, BALI100,NITRO50, NRG LC50, BOOXTER, BWS50, BWS100, DIO50, DIO70,&nbsp;DIO ZX 50, DIO ZX 70,&nbsp;CIAO, PIAGO, AM6, TZR50, HORIZENTAL, YAMAHA 3KJ, SR50, SR70, AXIS90, AXIS100, DX100, LEAD100, AD50, DERBI, SEPIA, PUCH, PEOGOET103-02, MBK AV7, VISION, OVETTO50, NH80, ROX50, FOX50, MBK AV10, DT50 LC, RZ50LC 88-93, GY6-150, BUXY70, DT125R, BWS70, TB50, T80, DERBI, &nbsp;NH50, MAJESTY125, MAJESTY126, X8-R, COBRA, MOBYLETTE AV10, BERBI SENDA2006, BERBI SENDA2005, SH150, AD50, WH150, TB50, CH250, C100/DY100, JH70, JH110, JH125, CB150, CB200, CG125, YBR125, CG250-OHV, VIPER/ZS200 GS, VINO-50, SYM125</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>MIDDLE EAST</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>AN125, AN150, MIO125, UZ125, UZ/V125, DIO50 ZX, YP250, MIO150 2V, MIO150 4V, GY6-50, GY6-80,&nbsp;GY6-125, GY6-150, JOG50, JOG70, SYM125, SYM150, CG250, CB250, CB150, KVB110, JH70, L110 A, KAB, GS50, VINO 50, BWS50, BWS100, ZY100, ZY125, WH100, WH125, RE205, BAJAJ150, KS4&nbsp;&nbsp;</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>AFRICA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>RX115, RX125, RX135, RXZ135, AX100, YB100, CG125, CG150, CG200, DT125, A100, SY125, AG100, BILP, K90, GK125, CD110, CD110-15, CT100, CB110, AP125-9G, AP150,CB125, CB150,TVS160, RE205</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>BRAZIL&nbsp;</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>BIZ125, BROSS150, C70, C100, C100 DREAM, CARGO125, CB250, CB540E, CBX150, CBX200, CBX250, TWISER, CBX750, CG125, CBX/XRE 300, CG77/91,CG125(FAN2009), CG125 TODAY TODAS, XY50, XTZ125/YBR125 FACTOR 2009-2011, TITAN150, TITAN2000, TITAN2004, WEB100, XL125, XL150, ML/TUR83/XL 250, XLR125, XLS125, XLS250R, XR250 TORNADO2007-2008, XR200, XR200R, XT225, XTZ125,XTZ250 LANDER2007-2008, DAFRA SUPER 100, DAFRA SPEED150, DT125, KANSAS150, MAX125, LEAD110, NX4 FACCOM2006 STE 2008, NX150, NXR150, NX350 SHAR 1991 , PHOENIX, POP100(WAVE100), RD125/135, SUZUKI YES125, YS250 FAZER2006, TITAN99,KS/ES 02/05/FAN/NXR, TW/TR 250, SHINNERAY50, MOPED, NEO 115 YAMAHA, CRF230</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>ARGENTINA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>GXT200, C70, DAX70, C90, C100, C110, CD110, MAX110, CG200, HJ200, CG150, HJ150, CG125, HJ125, GY6-50, GY6-60, GY6-80, GY6-100, SCOOTER125, GY6-125, SCOOTER150, GY6-150, WAVE110, NX200, CBX200, TITAN150, TITAN99, TITAN2000, RX100, YBR125,&nbsp; HONDA NXR125 BRPSS,&nbsp; HONDA STROM125, WAVE110, GILERA SMASH</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>MEXICO</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>LIFAN110, WAVE110, AT110, DINAMO APRISA 110, C110,&nbsp; ITALIKA FT125 CG125,&nbsp; ITALIKA FT150 CG150,&nbsp; TITAN2000,&nbsp; GY6-125 CS125 DS125, GY6-150 DS150,&nbsp; ST70 APRISA ZANETTI 70CC, HONDA C90,&nbsp; HONDA BROSS125,&nbsp; HONDA BROSS150,&nbsp; HONDA XR200,&nbsp; CG200,&nbsp; HONDA CARGO125, HONDA CARGO150, TITAN150, YBR125, CARPTON</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>COLUMBIA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>LIBERO, LB50, MT90/V50, PULSAR, FC80, RJ/STORM, RG100,RX100,RX115, RX125, RX135, RXK, SMASH110, SONIC 2003/2004, STROM, SUPRA, T50, TENA, TIGER, TITAN99, TITAN150, TR125, TS100, TS125E, TS100ERZ, TS185ERZ, WAVE, V50, V80, WY147, XF90, XF125, XL125, XL185, XR200, XRM, YAMAHA BWS125, YBR125, AKT110, AK125, AKT125, AX100, AXIS90, JOG90, PULSAR135, BOXER CT100, C50, C70, C90, C100, C110, CARGO125,&nbsp; CARGO150, CBF150, SUPER135, CD100, BIZ, CG125, CG150, EN125, AX125, CM125, CRYPTON, CUB, DISCOVER, DT125, DT125K, DT175K, DY90, DY100, ECO, EM125, EN125, FD115, FR50, FR80, CAS, GD116, GD125, GL-125, GLX50, GLX90, GN125, GN125H, GRAND, GS125, GSX, GY6-150, GY6-200, HERO, HONDA WAVE, HONDA CB150, JD100, JH70, JH150, K90, LEAD90, GSD-16</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>TURKEY</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>CUB, CUB LIF3VALF, CUB110, CG125, CG150, CG200, CG250, YBR125, ACTIVA, SCT125, SCT150, FIZY, SPACY, CBF125, CBF150, GY6-50, GY6-125, GY6-150, WH100, WH125, AN125, CD70, CD100, CD110, WAVE110, CY GNUS RS125, C110, CM125</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>RUSSIA</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>JH50, JH70, JH90, JH100, JH110, GY6-50, GY6-60,&nbsp;GY6-70, GY6-80,&nbsp;GY6-100, GY6-125,&nbsp;GY6-150, GY6-175, GY6-200, TB50, TB60, TB65, AD50, AD65, DIO50, DIO65, ZX50, ZX65, TACT50, TACT60, JOG50, JOG65, JOG90, AXIS90, LEAD50, LEAD90, LEAD100, AF18, AF24, AF28, AF34, AF35, AF36, CG125, CBT125, CB125, CB150, CB200, CB250, STORM125, DELTA110, APLHA110, CBB200, CBB250, ZODIAK, SIGMA125</span></span></span></span></span></span>
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color:#ffffff;height:96.00pt;text-align:left;"><span
                              style="font-size:14px;"><span style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>OTHER COUNTRY</span></span></span></span></span></span>
                          </td>
                          <td style="background-color:#ffffff;text-align:left;"><span style="font-size:14px;"><span
                              style="color:#222222;"><span
                              style="font-family:Arial, Helvetica, sans-serif;"><span><span><span>CG125, CG150, CG200, JH7O, JH90, JH100, JH110, WAVE110, GY6-125, GY6-150, JOG50, CBX150, NX150, PULSAR180, NXR125, RXS115 BAJAJ BOXER CT100, BAJAJ BOXER BM100, BAJAJ BOXER BM150, BAJAJ PULSAR135, BAJAJ PULSAR150, BAJAJ PULSAR180, BAJAJ PULSAR200, BAJAJ PULSAR220, BAJAJ DISCOVER125, BAJAJ DISCOVER135 BAJAJ XCD125, BAJAJ 2T 3W, BAJAJ 4T 3W</span></span></span></span></span></span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <br>&nbsp;
                    </body>
                    </html>
                  </div>
                </div>
              </div>
            </div>
            <div class="sr-layout-subblock detail-tab-item J-tab-cnt company-profile-block"
                 style="display: none;height: 1024px;overflow: hidden;">
              <img
                  src=""
                  width="1118" height="1024">
              <button class="J-com-profile-view-more"
                      style="position: absolute;bottom: 0;background: #fff;width: 100%;text-align: center;padding: 10px;border: none; line-height: 1.5;">
                View More <i class="ob-icon icon-down"></i></button>
            </div>
            <div class="sr-layout-subblock detail-tab-item J-tab-cnt" style="display: none;">
              <div class="sr-layout-content">
                <div class="question">
                  <div class="qa-form obelisk-form">
                    <input type="hidden" id="canSendQaInquiry" value="false">
                    <input type="hidden" id="qaFormshowRoomUrl"
                          >

                      <div class="qa-form-history-wp">
                        <textarea name="content" id="qaContent" cols="30" rows="2"
                                  placeholder="Enter your question about this product"
                                  class="input-textarea qa-form-area J-question-content" maxlength="200"></textarea>
                        <div class="qa-form-history J-his-qa-wp" style="display: none;">
                          <div class="qa-history-wrap">
                            <ul class="qa-history-list">
                              <li class="qa-history-lable">
                                Typical questions asked about products
                              </li>
                              <li class="qa-history-item J-his-qa">
                                Does this product support customization?
                              </li>
                              <li class="qa-history-item J-his-qa">
                                How do you ship the products?
                              </li>
                              <li class="qa-history-item J-his-qa">
                                What is the warranty for the product?
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="feedback-block" wrapfor="qaContent"><label for="qaContent" generated="true"
                                                                               class="error"
                                                                               style="display: none;"></label></div>
                      </div>
                      <div class="qa-form-tip">Once receive your question, the supplier will answer you as soon as
                        possible.
                      </div>
                      <button type="submit" class="btn btn-small btn-main qa-form-btn" id="qaSend">Send</button>

                  </div>
                  <div class="qa-info-list J-qa-info-list">
                  </div>
                  <div class="qa-pager J-qa-pager"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sr-layout-extra detail-extra">
          <div class="sr-layout-block J-yml-place" style="padding: 20px" faw-module="YML">
            <div class="sr-side-maylike-block">
              <div class="sr-txt-title sr-txt-rightSpace">
                <h2 class="sr-txt-h2">You Might Also Like</h2> <i
                  class="ob-icon icon-rotate-r J-data-refresh-times J-yml-refresh" style="display:none"></i>
              </div>
              <div class="sr-side-maylike-wrap cf J-yml-list-wrap">
                <div class="sr-layout-content sr-side-maylike-cnt cf J-yml-list">


                  <div class="sr-side-maylike-item" faw-exposure=""
                       ads-data="st:8,pdid:lSgETZHjgWpm,pcid:MbqJekDAbTiS,a:1" faw-id="1hnnajsima5f">
                    <div class="sr-side-maylike-pic"><a
                        href=""
                        title="Motorcycle Parts Engine Cylinder Block Kit for Honda CG125 (STD) (SMALL FIN) (LARGE 62mm) CG100 CG150 CG175 CG200 CG250 CG300 AK125SL/M.V AK125S-SL/NKD/M.N."
                        ads-data="st:8,pdid:lSgETZHjgWpm,pcid:MbqJekDAbTiS,a:1" class="J-data-stat" cz-id="753410492"
                        cz-type="0" cz-from="2" cz-times="0" cz-random="0"> <img
                        src="https://sara-infinity.com/10.png"
                        alt="Motorcycle Parts Engine Cylinder Block Kit for Honda CG125 (STD) (SMALL FIN) (LARGE 62mm) CG100 CG150 CG175 CG200 CG250 CG300 AK125SL/M.V AK125S-SL/NKD/M.N.">
                    </a></div>
                    <div class="sr-side-maylike-txt">
                      <div class="sr-side-maylike-name"><a
                          href=""
                          title="Motorcycle Parts Engine Cylinder Block Kit for Honda CG125 (STD) (SMALL FIN) (LARGE 62mm) CG100 CG150 CG175 CG200 CG250 CG300 AK125SL/M.V AK125S-SL/NKD/M.N."
                          ads-data="st:8,pdid:lSgETZHjgWpm,pcid:MbqJekDAbTiS,a:1" class="J-data-stat" cz-id="753410492"
                          cz-type="0" cz-from="2" cz-times="0" cz-random="0"> Motorcycle Parts Engine Cylinder Block Kit
                        for Honda CG125 (STD) (SMALL FIN) (LARGE 62mm) CG100 CG150 CG175 CG200 CG250 CG300 AK125SL/M.V
                        AK125S-SL/NKD/M.N. </a></div>
                      <div class="sr-side-maylike-price" title="US $8.4-10 / Set"><span class="sr-side-maylike-num">US $8.4-10</span>
                        <span class="sr-side-maylike-unit"> / Set</span></div>
                    </div>
                  </div>


                  <div class="sr-side-maylike-item" faw-exposure="" ads-data="st:8,pdid:uNyEkbzMyjVs,pcid:MbqJekDAbTiS,a:2" faw-id="1hnnajsind61">	<div class="sr-side-maylike-pic">		<a href="" title="High Quality Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300" ads-data="st:8,pdid:uNyEkbzMyjVs,pcid:MbqJekDAbTiS,a:2" class="J-data-stat" cz-id="888358365" cz-type="0" cz-from="2" cz-times="0" cz-random="0">			<img src="https://sara-infinity.com/4.png" alt="High Quality Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300">		</a>	</div>	<div class="sr-side-maylike-txt">		<div class="sr-side-maylike-name">			<a href="" title="High Quality Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300" ads-data="st:8,pdid:uNyEkbzMyjVs,pcid:MbqJekDAbTiS,a:2" class="J-data-stat" cz-id="888358365" cz-type="0" cz-from="2" cz-times="0" cz-random="0">				High Quality Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300			</a>		</div>		<div class="sr-side-maylike-price" title="US $9-10 / Set">			<span class="sr-side-maylike-num">US $9-10</span>			<span class="sr-side-maylike-unit"> / Set</span>		</div>	</div></div>


                  <div class="sr-side-maylike-item" faw-exposure="" ads-data="st:8,pdid:JOVTqFtlHAfX,pcid:MbqJekDAbTiS,a:3" faw-id="1hnnajsin745">	<div class="sr-side-maylike-pic">		<a href="" title="motorcycle engines zongshen dirt bike partsCG 200 CG 250 off Road Engine Parts" ads-data="st:8,pdid:JOVTqFtlHAfX,pcid:MbqJekDAbTiS,a:3" class="J-data-stat" cz-id="1915167091" cz-type="0" cz-from="2" cz-times="0" cz-random="0">			<img src="https://sara-infinity.com/4.png" alt="motorcycle engines zongshen dirt bike partsCG 200 CG 250 off Road Engine Parts">		</a>	</div>	<div class="sr-side-maylike-txt">		<div class="sr-side-maylike-name">			<a href="" title="motorcycle engines zongshen dirt bike partsCG 200 CG 250 off Road Engine Parts" ads-data="st:8,pdid:JOVTqFtlHAfX,pcid:MbqJekDAbTiS,a:3" class="J-data-stat" cz-id="1915167091" cz-type="0" cz-from="2" cz-times="0" cz-random="0">				motorcycle engines zongshen dirt bike partsCG 200 CG 250 off Road Engine Parts			</a>		</div>		<div class="sr-side-maylike-price" title="US $9-10 / Set">			<span class="sr-side-maylike-num">US $9-10</span>			<span class="sr-side-maylike-unit"> / Set</span>		</div>	</div></div>


                  <div class="sr-side-maylike-item" faw-exposure="" ads-data="st:8,pdid:xjvneduAnskL,pcid:MbqJekDAbTiS,a:4" faw-id="1hnnajsind95">	<div class="sr-side-maylike-pic">		<a href="" title="Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300" ads-data="st:8,pdid:xjvneduAnskL,pcid:MbqJekDAbTiS,a:4" class="J-data-stat" cz-id="887363095" cz-type="0" cz-from="2" cz-times="0" cz-random="0">			<img src="https://sara-infinity.com/4.png" alt="Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300">		</a>	</div>	<div class="sr-side-maylike-txt">		<div class="sr-side-maylike-name">			<a href="" title="Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300" ads-data="st:8,pdid:xjvneduAnskL,pcid:MbqJekDAbTiS,a:4" class="J-data-stat" cz-id="887363095" cz-type="0" cz-from="2" cz-times="0" cz-random="0">				Motorcycle Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300			</a>		</div>		<div class="sr-side-maylike-price" title="US $8 / Set">			<span class="sr-side-maylike-num">US $8</span>			<span class="sr-side-maylike-unit"> / Set</span>		</div>	</div></div>


                  <div class="sr-side-maylike-item" faw-exposure="" ads-data="st:8,pdid:UyjmOEMHENVr,pcid:MbqJekDAbTiS,a:5" faw-id="1hnnajsin833">	<div class="sr-side-maylike-pic">		<a href="" ads-data="st:8,pdid:UyjmOEMHENVr,pcid:MbqJekDAbTiS,a:5" class="J-data-stat" cz-id="888692205" cz-type="0" cz-from="2" cz-times="0" cz-random="0">			<img src="https://sara-infinity.com/4.png" alt="High Quality Scooter Engine Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300">		</a>	</div>	<div class="sr-side-maylike-txt">		<div class="sr-side-maylike-name">			<a href="" title="High Quality Scooter Engine Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300" ads-data="st:8,pdid:UyjmOEMHENVr,pcid:MbqJekDAbTiS,a:5" class="J-data-stat" cz-id="888692205" cz-type="0" cz-from="2" cz-times="0" cz-random="0">				High Quality Scooter Engine Parts Cylinder Block Kit for Honda CG 125 (STD) (SMALL FIN) (LARGE 62mm) CG 100 CG 150 CG 175 CG 200 CG 250 CG 300			</a>		</div>		<div class="sr-side-maylike-price" title="US $8 / Set">			<span class="sr-side-maylike-num">US $8</span>			<span class="sr-side-maylike-unit"> / Set</span>		</div>	</div></div>


                </div>
              </div>
            </div>
          </div>
          <div class="sr-layout-block" faw-module="Prod_group_filter" faw-exposure style="padding: 20px">
            <div class="sr-layout-subblock sr-side-searchBar">
              <form class="sr-side-searchBar-wrap obelisk-form" name="searchInKeywordSide"
                    action="/product/keywordSearch" method="get">
                <input class="sr-side-searchBar-input input-text" placeholder="Search Products" type="text"
                       name="searchKeywordSide">
                <button class="sr-side-searchBar-button" type="submit"><i class="micon">&#xe040;</i></button>
              </form>
            </div>
            <div class="sr-layout-subblock sr-side-proGroup" faw-module="Prod_group_filter" faw-exposure>
              <div class="sr-txt-title">
                <h2 class="sr-txt-h2">Product Groups</h2>
              </div>
              <ul class="sr-side-proGroupR-list">
                <li>
                  <a ref="nofollow"
                     href=""
                     title="Motorcycle Cylinder Kits For HONDA">
                    Motorcycle Cylinder Kits For HONDA
                  </a>
                </li>
                <li>
                  <a ref="nofollow"
                     href=""
                     title="Motorcycle Cylinder Kits For YAMAHA">
                    Motorcycle Cylinder Kits For YAMAHA
                  </a>
                </li>
                <li>
                  <a ref="nofollow"
                     href=""
                     title="Motorcycle Cylinder Kits For SUZUKI">
                    Motorcycle Cylinder Kits For SUZUKI
                  </a>
                </li>
                <li>
                  <a ref="nofollow"
                     href=""
                     title="Motorcycle Cylinder Kits For BAJAJ">
                    Motorcycle Cylinder Kits For BAJAJ
                  </a>
                </li>
                <li>
                  <a ref="nofollow"
                     href=""
                     title="Motorcycle Cylinder Kits For PIAGGIO">
                    Motorcycle Cylinder Kits For PIAGGIO
                  </a>
                </li>
                <div class="J-more-list" style="display: none">
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Cylinder Kit For HERO">
                      Motorcycle Cylinder Kit For HERO
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Cylinder Kits For TVS">
                      Motorcycle Cylinder Kits For TVS
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title=" Motorcycle Bigbore Racing Cylinder Kits">
                      Motorcycle Bigbore Racing Cylinder Kits
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Engine">
                      Motorcycle Engine
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Piston Ring Kit">
                      Motorcycle Piston Ring Kit
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Gasket">
                      Motorcycle Gasket
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Spark Plug">
                      Motorcycle Spark Plug
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Motorcycle Carburetor">
                      Motorcycle Carburetor
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Chainsae &amp; Grasscutter Cylinder Kits">
                      Chainsae &amp; Grasscutter Cylinder Kits
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Outboard Engine Cylinder Liner Sleeve">
                      Outboard Engine Cylinder Liner Sleeve
                    </a>
                  </li>
                  <li>
                    <a ref="nofollow"
                       href=""
                       title="Other Motorcycle Cylinder Kits">
                      Other Motorcycle Cylinder Kits
                    </a>
                  </li>
                </div>
                <li class="sr-side-proGroupR-moreSpace more ">
                  <span class="J-show-moreGroup moreGroup"><span id="more">More</span> <i
                      class="ob-icon icon-down J-progroup-icon"></i></span>
                  <a class="group-pdf" href="/Product-Catalogs/" target="_blank"><i class="ob-icon icon-pdf"></i>
                    Product Catalogs</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="J-contact-button-clone" style="display:none;margin-bottom: 20px"></div>
          <div class="sr-layout-block J-contact-button-place sr-contact-button-place block-bottom">
            <div faw-module="sendInquiry" faw-exposure>
              <div>
                <div class="J-order-text order-text">
                  <div class="flex-box">
                    <div class="flex-text" style="font-weight: bold">
                      From payment to delivery, we protect your trading.
                    </div>
                  </div>
                </div>
                <div class="sr-side-product-info J-product-info">
                  <div class="sr-side-product-img">
                    <img
                        src="//image.made-in-china.com/200f0j00DPaYTfpgunqS/High-Quality-Motorcycle-Parts-Cylinder-Kit-for-Honda-CG150-AKT150-SY150-EVO-NE-AKT150TT-EVO150.webp"
                        alt="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150 pictures & photos"
                        title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                  </div>
                  <div class="sr-side-product-txt">
                    <div class="sr-side-product-name"
                         title="High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150">
                      High Quality Motorcycle Parts Cylinder Kit for Honda CG150 AKT150 SY150 EVO-NE AKT150TT/ EVO150
                    </div>
                    <div class="sr-side-product-price" title="US $9-10 / Set">
                      <span class="sr-side-product-num">US $9-10 </span>
                      <span class="sr-side-product-unit">/ Set</span>
                    </div>
                    <div class="sr-side-product-price" title="Min. Order: 100 Sets">
                      <span class="sr-side-product-unit">Min. Order: </span>
                      100 Sets
                    </div>
                  </div>
                </div>

                <div class="button-block">
                  <a fun-inquiry-product class="btns button-link-contact" target="_blank"

                     rel="nofollow" ads-data="st:5,pdid:pvImKCyLaEfT,pcid:MbqJekDAbTiS"><i
                      class="ob-icon icon-mail"></i>Contact Now</a>
                </div>

                <div class="button-block sr-proMainInfo-baseInfo-actActs">
            <span class="act-item">
    <span class="J-added-to-basket already-in-basket pvImKCyLaEfT" style="display:none">
         <a href="javascript:;" onclick="showMiniInquiry('product');"
            ads-data="st:6,pdid:pvImKCyLaEfT,pcid:MbqJekDAbTiS">
              <i class="micon">&#xe05f;</i>Inquiry Basket </a>
     </span>
    <span class="J-add-to-basket pvImKCyLaEfT add-to-basket" style="">

            </span>
</span>
                </div>
              </div>
            </div>
          </div>
          <div class="J-com-place-clone" style="display:none;margin-bottom: 20px"></div>
          <div class="sr-layout-block J-com-place sr-com-place sr-com-place-bottom">
            <div faw-module="company_homepage" faw-exposure>
              <input type="hidden" id="J-linkInfo" value="">
              <div class="sr-linkTo-comInfo J-linkTo-comInfo" ads-data>
                <div class="sr-com com-place-one">
                  <div class="sr-com-logo">
                    <img src="/"
                       />
                  </div>
                  <div class="sr-com-info">
                    <div class="sr-comInfo-title ">
                      <div class="title-txt">
                        <a  target="_blank" ads-data
                           title="NINGBO DAXIE DEVELOPMENT ZONE HUASHAN MACHINERY CO., LTD.">NINGBO DAXIE DEVELOPMENT
                          ZONE HUASHAN MACHINERY CO., LTD. <i class="ob-icon icon-right"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sr-comInfo-sign com-place-two">
                  <div class="sign-item">
                    <i class="item-icon icon-gold"></i>
                    Gold Member <span class="txt-year">Since 2019</span>
                    <div class="tip arrow-bottom tip-gold">
                      <div class="gold-content">
                        <div class="tip-con">
                          <p class="tip-para">Suppliers with verified business licenses</p>
                        </div>
                        <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
                      </div>
                    </div>
                  </div>
                  <div class="sign-item as-logo" style="margin-top: 8px"
                       data-title="Audited by an independent third-party inspection agency">
                    <img class="item-icon" src=""
                        alt=""/>
                    Audited Supplier
                  </div>
                  <div class="sign-item" style="margin-top: 8px">
                    <i class="item-icon icon-deal"></i>
                    Secured Trading Service
                  </div>
                  <div class="review-scores">
                    <div class="score-item score-item-rating">Rating: <span><a class="J-company-review" target="_self"
                                                                              >4.6/5</a></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="com-place-three">
                <div class="detail-col mod-2">
                  <div class="detail-infos">
                    <div class="info-item info-businessType" title="Manufacturer/Factory">
                      Manufacturer/Factory
                    </div>
                    <div class="info-item ">
                      <div class="info-label" title="OEM/ODM Availability">
                        OEM/ODM Availability
                      </div>
                      <div class="info-fields" title="OEM, ODM">
                        Yes
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>



    <!-----------------------------------------------------------------------------------底部------------------------------------------------------------------------->
    <div class="m-footer pad-footer m-sr-footer">
      <div class="grid">
        <div class="m-footer-simple-links pad-footer-simple">
          <div class="m-footer-simple-links-group pad-footer-hide">
            <div class="m-footer-simple-links-row">
              <a>{{language?"热门产品":"Hot Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国产品":"China Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国制造商/供应商":"Chinese Manufacturers/Suppliers"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国批发":"China Wholesale"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"批发价格":"Wholesale Price"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"行业网站":"Industry Sites"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"区域渠道":"Regional Channels"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"产品指数":"Product Index"}}</a>

            </div>

          </div>
          <div class="m-footer-simple-links-group pad-footer-oneline">
            <div class="m-footer-simple-links-row m-footer-copyright">
              Copyright &copy; 2023-2024 <a class="J-focusChinaLink" href="https://www.sara-infinity.com/"
                                            rel="nofollow"
                                            target="_blank">{{language?"广州至臻机车配件有限公司":"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."}}</a>&nbsp;{{language?"保留所有权利":"All Rights Reserved."}}

            </div>
            <span class="m-gap-line"></span>
            <div class="m-footer-simple-links-row">
              <a rel="nofollow" target="_self">{{language?"保留所有权利":"User Agreement"}}</a>
            </div>
          </div>
          <div style="display: flex;justify-content: center;width: 100%">

            <div class="m-footer-simple-links-row m-footer-govIcon pad-hide" style="color: blue" >
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483772" rel="noreferrer" target="_blank"><i class="m-ico m-ico-police-new"></i>粤公网安备44011102483772</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" data-v-644aa589="" style="margin-left: 20px;">粤ICP备2024199978号</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      localImage: require('@/assets/img/logo.jpg'),
      loading: false,
      passFocus: false,
      isCetc: true,
      formWidth: '',
      bgImage: '',
      form: {
        username: '',
        password: '',
        platform: ''
      },
      list: []
    }
  },
  methods: {


    isIE() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.info('ie浏览器不兼容！')
        return true;
      }
      return false;
    },

  },

  mounted() {
    let random = Math.floor(Math.random() * 5) + 1;
    this.bgImage = {
      backgroundImage: 'url(' + require('../assets/img/bg.jpg'),
      backgroundRepeat: 'no-repeat',

    };
    if (this.isIE()) {
      this.$confirm('此平台不兼容ie浏览器，使用ie浏览器可能会出现未知错误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      });
    }

    this.formWidth = 'width: 500px;'

  }
}
</script>

<style scoped>
.catalogForm .form-label {
  width: 190px;
}

.catalogForm .form-label em {
  color: #e64545;
  margin-right: 5px;
}

.catalogForm .form-fields {
  margin-left: 200px;
}

.shipping-cost-tm .tm-status-off {
  background: none;
  padding: 0;
  color: #1470cc
}

</style>
